import css from 'styled-jsx/css'
import { colors, grids } from '../../styles'

export default css`
.Group {
  padding-top: 1rem;
}

.Group:first-child {
  padding-top: 0;
}
.Group.live{
}
.sponsorship
:global(.CardRefresh:first-of-type) {
  margin-left: 0;
  width: 250px;
  min-width: 250px;
  position: relative;
  bottom: 0px;
  transition: none;
  transition-delay: none;
  margin-bottom: 0;
}

.sponsorship {
  background: ${colors.sponsorshipBg};
  padding-top: 1em;
}

.sponsorship
:global(.display1) {
  color: ${colors.white};
}

.sponsorship
:global(.CardRefresh) {
  margin-bottom: 0;
}

.sponsorship
:global(.Scroller) {
  border-bottom: none;
}

.sponsorship
:global(.CardRefresh:first-of-type figure) {
  transition: none !important;
  transform: none !important;
  margin-bottom: -5px;
}

.sponsorship
:global(.CardRefresh:first-of-type .Image) {
  padding-bottom: 76.75%;
}

.sponsorship
:global(.CardRefresh:first-of-type .image-wrapper::after) {
  box-shadow: inset -50px 40px 40px #201D22;
  content: '';
  display: block;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
}

.sponsorship
:global(.cardTitle1, .cardLabel, .cardSubtitle){
  color: ${colors.white};
}

.SpecialEventCard
:global(.preview-image .Image) {
  padding-bottom: 0;
  width: 100%;
  height: 100vw;
}
.SpecialEventCard
:global(.preview-image img) {
  height: 100vw;
  object-fit: cover;
}

@media (min-width: 1024px) {
  .SpecialEventCard
  :global(.preview-image .Image) {
    top: 0;
    aspect-ratio: 16 / 9;
    height: auto;

  }

  .SpecialEventCard {
  }

}

@media (min-width: 768px) {
  .SpecialEventCard
  :global(.preview-image .Image) {
    top: 0;
    width: 100%;
    height: auto;
    min-height: 420px;
  }
  .SpecialEventCard {
  }

}

@media (min-width: 1200px) {
  .SpecialEventCard
  :global(.preview-image .Image) {

  }

  .SpecialEventCard {
  }

  .chevron-left, .chevron-right {
    top: 35%;
    position: absolute;
    cursor: pointer;
  }

  .chevron-left {
    left: 0;
  }
  .chevron-right {
    right: 0;
    z-index: 1;
  }
}

@media (min-width: ${grids.medium.breakpoint}px) {
  .sponsorship
  :global(.CardRefresh:first-of-type) {
    width: 350px;
    min-width: 350px;
    margin-right: 0;
    bottom: 15px;
  }

  .sponsorship
  :global(.CardRefresh:first-of-type figure) {
    margin-bottom: -20px;
  }

  .SpecialEventCard
  :global(.preview-image img) {
    height: auto;
    object-fit: cover;
  }
}
`
